export default __webpack_public_path__ + "static/media/MicroGrid_001.5109b10a.png";